/**
 * CustomHolsterSelector
 * Parameterized client-side engine for holster product variant options (Manufacturer, Gun, Draw Hand, Light/Laser, Optic Cut)
 */
window.CustomHolsterSelector = function(config) {
  'use strict';

  const prefix = config.prefix || 'cloak-tuck';
  const sectionId = config.sectionId;
  const productId = config.productId;
  const defaultPrice = config.defaultPrice || 79.99;
  const dataUrl = config.dataUrl;
  const hideLight = config.hideLight || false;
  const hideOptic = config.hideOptic || false;
  const showSize = config.showSize || false;

  const pickerId = prefix + '-picker';
  const statusId = prefix + '-status';
  const handId = prefix + '-hand';
  const lightId = prefix + '-light';
  const lightRowId = prefix + '-light-row';
  const opticId = prefix + '-optic';
  const opticRowId = prefix + '-optic-row';
  const sizeId = prefix + '-size';

  let allVariants = [];
  let shopifyVariants = [];
  let selectedGun = null;
  let selectedHand = null;
  let selectedLight = null;
  let selectedOptic = null;
  let selectedSize = null;
  let activeMfrFilter = '';

  // ----------------------------------------------------------------
  // URL Parameter Pre-fill
  // ----------------------------------------------------------------
  function prefillFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var manufacturerParam = params.get('manufacturer');
    var gunParam = params.get('gun');
    var handParam = params.get('hand');
    var lightParam = params.get('light');
    var opticParam = params.get('optic');

    if (!manufacturerParam && !gunParam) return;

    setTimeout(function() {
      if (gunParam) {
        var gunOptions = getGunOptions();
        var gunFound = gunOptions.find(function(opt) {
          return opt.value === gunParam || slugify(opt.value) === gunParam;
        });

        if (!gunFound && manufacturerParam) {
          var mfrOptions = getMfrOptions();
          var mfrFound = mfrOptions.find(function(opt) {
            return opt.value && (opt.value === manufacturerParam || slugify(opt.value) === manufacturerParam);
          });
          if (mfrFound) {
            activeMfrFilter = mfrFound.value;
            var mfrSS = document.getElementById('cloak-ss-mfr');
            if (mfrSS && mfrSS._ss) mfrSS._ss.setValue(mfrFound.value, mfrFound.label);
          }
          gunOptions = getGunOptions();
          gunFound = gunOptions.find(function(opt) {
            return opt.value === gunParam || slugify(opt.value) === gunParam;
          });
        }

        if (gunFound) {
          var gunSS = document.getElementById('cloak-ss-gun');
          if (gunSS && gunSS._ss) gunSS._ss.setValue(gunFound.value, gunFound.value);

          selectedGun = gunFound.value;
          selectedHand = null;
          selectedLight = null;
          selectedOptic = null;

          if (!activeMfrFilter) {
            if (manufacturerParam) {
              var mfrOptions = getMfrOptions();
              var mfrFound = mfrOptions.find(function(opt) {
                return opt.value && (opt.value === manufacturerParam || slugify(opt.value) === manufacturerParam);
              });
              if (mfrFound) {
                activeMfrFilter = mfrFound.value;
                var mfrSS = document.getElementById('cloak-ss-mfr');
                if (mfrSS && mfrSS._ss) mfrSS._ss.setValue(mfrFound.value, mfrFound.value);
              }
            } else {
              var mfr = getMfrForGun(selectedGun);
              if (mfr) {
                activeMfrFilter = mfr;
                var mfrSS = document.getElementById('cloak-ss-mfr');
                if (mfrSS && mfrSS._ss) mfrSS._ss.setValue(mfr, mfr);
              }
            }
          }

          var handEl = document.getElementById(handId);
          if (handEl) handEl.value = '';
          refreshHandedness();
          if (showSize) refreshSize();
          refreshLight();
          refreshOptic();

          if (handParam && handEl) {
            var handMatch = Array.from(handEl.options).find(function(opt) {
              return opt.value && (opt.value === handParam || slugify(opt.value) === handParam);
            });
            if (handMatch) {
              handEl.value = handMatch.value;
              selectedHand = handMatch.value;
              selectedLight = null;
              selectedOptic = null;
              if (showSize) selectedSize = null;
              if (showSize) refreshSize();
              refreshLight();
              refreshOptic();

              var sizeParam = params.get('size');
              if (showSize && sizeParam) {
                var sizeEl = document.getElementById(sizeId);
                if (sizeEl) {
                  var sizeMatch = Array.from(sizeEl.options).find(function(opt) {
                    return opt.value && (opt.value === sizeParam || slugify(opt.value) === sizeParam);
                  });
                  if (sizeMatch) {
                    sizeEl.value = sizeMatch.value;
                    selectedSize = sizeMatch.value;
                  }
                }
              }

              if (lightParam) {
                var lightEl = document.getElementById(lightId);
                if (lightEl) {
                  var lightMatch = Array.from(lightEl.options).find(function(opt) {
                    return opt.value && (slugify(opt.value) === lightParam || (opt.value === '__none__' && lightParam === 'no-light'));
                  });
                  if (lightMatch) {
                    lightEl.value = lightMatch.value;
                    selectedLight = lightMatch.value === '__none__' ? null : lightMatch.value;
                    refreshOptic();

                    if (opticParam) {
                      var opticEl = document.getElementById(opticId);
                      var targetOptic = opticParam === 'yes';
                      if (opticEl) {
                        var opticMatch = Array.from(opticEl.options).find(function(opt) {
                          return opt.value === String(targetOptic);
                        });
                        if (opticMatch) {
                          opticEl.value = opticMatch.value;
                          selectedOptic = targetOptic;
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          trySelect();
          updateUrl();
        }
      } else if (manufacturerParam) {
        var mfrOptions = getMfrOptions();
        var found = mfrOptions.find(function(opt) {
          return opt.value && (opt.value === manufacturerParam || slugify(opt.value) === manufacturerParam);
        });
        if (found) {
          var mfrSS = document.getElementById('cloak-ss-mfr');
          if (mfrSS && mfrSS._ss) mfrSS._ss.setValue(found.value, found.value);
          activeMfrFilter = found.value;
          selectedGun = null;
          var gunSS = document.getElementById('cloak-ss-gun');
          if (gunSS && gunSS._ss) gunSS._ss.reset();
          selectedHand = null;
          var handEl = document.getElementById(handId);
          if (handEl) handEl.value = '';
          refreshLight();
          refreshOptic();
          trySelect();
          updateUrl();
        }
      }
    }, 500);
  }

  // ----------------------------------------------------------------
  // URL Management
  // ----------------------------------------------------------------
  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function updateUrl() {
    var params = new URLSearchParams();
    if (activeMfrFilter) params.set('manufacturer', slugify(activeMfrFilter));
    if (selectedGun) params.set('gun', slugify(selectedGun));
    if (selectedHand) params.set('hand', slugify(selectedHand));
    if (showSize && selectedSize) params.set('size', slugify(selectedSize));
    if (selectedLight) params.set('light', slugify(selectedLight));
    if (selectedOptic !== null) params.set('optic', selectedOptic ? 'yes' : 'no');
    var query = params.toString();
    history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
  }

  // ----------------------------------------------------------------
  // Boot
  // ----------------------------------------------------------------
  function boot() {
    var productDataEl = document.getElementById(prefix + '-product-data');
    if (productDataEl) {
      try {
        shopifyVariants = JSON.parse(productDataEl.textContent) || [];
      } catch (e) {}
    }

    if (defaultPrice != null) {
      var defaultCompareAt = null;
      var defaultVariant = shopifyVariants.find(function(v) { return v.available; }) || shopifyVariants[0];
      var activeDefaultPrice = defaultPrice;
      if (defaultVariant) {
        defaultCompareAt = defaultVariant.compare_at_price;
        if (defaultVariant.price != null) {
          activeDefaultPrice = defaultVariant.price;
        }
      }
      setTimeout(function() { updatePrice(activeDefaultPrice, defaultCompareAt); }, 0);
    }

    var addBtn = document.querySelector('button[name="add"]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
    }

    var url = dataUrl;
    if (url.indexOf('//') === 0) url = 'https:' + url;

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        allVariants = data.variants || data;
        if (!allVariants || !allVariants.length) {
          showPickerError('No variant data found.');
          return;
        }
        buildUI();
        prefillFromUrl();
      })
      .catch(function (e) {
        showPickerError('Could not load gun models. Please refresh the page.');
      });
  }

  // Search aliases
  var MANUFACTURER_ALIASES = {
    'S&W': ['smith', 'smith & wesson', 'smith and wesson', 'sw'],
    'H&K': ['hk', 'heckler', 'heckler & koch', 'heckler and koch', 'koch'],
    'PSA': ['psa', 'palmetto', 'palmetto state armory']
  };

  function fuzzyScore(needle, haystack) {
    if (!needle) return 1;
    needle = needle.toLowerCase().trim();
    haystack = haystack.toLowerCase();
    return haystack.indexOf(needle) !== -1 ? 1 : 0;
  }

  function getMfrOptions() {
    var seen = {};
    var list = [];
    allVariants.forEach(function (v) {
      if (v.manufacturer && !seen[v.manufacturer]) {
        seen[v.manufacturer] = true;
        var aliases = MANUFACTURER_ALIASES[v.manufacturer] || [];
        var searchText = [v.manufacturer].concat(aliases).join(' ');
        list.push({ value: v.manufacturer, label: v.manufacturer, searchText: searchText });
      }
    });
    list.sort(function (a, b) { return a.label.localeCompare(b.label); });
    list.unshift({ value: '', label: 'All Manufacturers', searchText: 'All Manufacturers' });
    return list;
  }

  function getGunOptions() {
    var seen = {};
    var list = [];
    allVariants.forEach(function (v) {
      if (!v.gun) return;
      if (activeMfrFilter && v.manufacturer !== activeMfrFilter) return;
      if (!seen[v.gun]) {
        seen[v.gun] = true;
        list.push({ value: v.gun, label: v.gun });
      }
    });
    list.sort(function (a, b) { return a.label.localeCompare(b.label); });
    return list;
  }

  function getMfrForGun(gun) {
    var seen = {};
    allVariants.forEach(function (v) {
      if (v.gun === gun && v.manufacturer) seen[v.manufacturer] = true;
    });
    var keys = Object.keys(seen);
    return keys.length === 1 ? keys[0] : null;
  }

  // Searchable select component
  function createSearchableSelect(wrapperId, getOptions, onSelect, emptyPlaceholder) {
    var wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;

    var trigger = wrapper.querySelector('.cloak-ss-trigger');
    var triggerLabel = wrapper.querySelector('.cloak-ss-trigger-label');
    var dropdown = wrapper.querySelector('.cloak-ss-dropdown');
    var searchInput = wrapper.querySelector('.cloak-ss-search');
    var list = wrapper.querySelector('.cloak-ss-list');

    var selectedValue = null;
    var selectedLabel = null;
    var focusedIndex = -1;

    function filterOptions(query) {
      var options = getOptions();
      if (!query) return options;
      return options
        .map(function (opt) { return { opt: opt, score: fuzzyScore(query, opt.searchText || opt.label) }; })
        .filter(function (x) { return x.score > 0; })
        .sort(function (a, b) { return b.score - a.score || a.opt.label.localeCompare(b.opt.label); })
        .map(function (x) { return x.opt; });
    }

    function renderList() {
      var query = searchInput.value;
      var filtered = filterOptions(query);
      focusedIndex = -1;

      if (!filtered.length) {
        list.innerHTML = '<div class="cloak-ss-empty">No results found</div>';
        return;
      }

      list.innerHTML = filtered.map(function (opt) {
        var sel = opt.value === selectedValue ? ' cloak-ss-selected' : '';
        return '<div class="cloak-ss-option' + sel + '" data-value="' + esc(opt.value) + '" data-label="' + esc(opt.label) + '">' + esc(opt.label) + '</div>';
      }).join('');
    }

    function openDropdown() {
      searchInput.value = '';
      renderList();
      dropdown.classList.add('open');
      searchInput.focus();
      var selected = list.querySelector('.cloak-ss-selected');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    function closeDropdown() {
      dropdown.classList.remove('open');
      focusedIndex = -1;
    }

    function selectOption(value, label) {
      selectedValue = value || null;
      selectedLabel = value ? label : null;
      triggerLabel.textContent = selectedLabel || emptyPlaceholder;
      trigger.classList.toggle('has-value', !!selectedLabel);
      closeDropdown();
      onSelect(value);
    }

    function getVisibleOptions() {
      return list.querySelectorAll('.cloak-ss-option');
    }

    function updateFocus(options) {
      options.forEach(function (o, i) {
        o.classList.toggle('cloak-ss-focused', i === focusedIndex);
        if (i === focusedIndex) o.scrollIntoView({ block: 'nearest' });
      });
    }

    wrapper._ss = {
      reset: function () {
        selectedValue = null;
        selectedLabel = null;
        triggerLabel.textContent = emptyPlaceholder;
        trigger.classList.remove('has-value');
        closeDropdown();
      },
      setValue: function (value, label) {
        selectedValue = value || null;
        selectedLabel = value ? label : null;
        triggerLabel.textContent = selectedLabel || emptyPlaceholder;
        trigger.classList.toggle('has-value', !!selectedLabel);
      }
    };

    trigger.addEventListener('click', function () {
      if (dropdown.classList.contains('open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (dropdown.classList.contains('open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }
    });

    searchInput.addEventListener('input', function () {
      renderList();
    });

    searchInput.addEventListener('keydown', function (e) {
      var options = getVisibleOptions();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusedIndex = Math.min(focusedIndex + 1, options.length - 1);
        updateFocus(options);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusedIndex = Math.max(focusedIndex - 1, 0);
        updateFocus(options);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (focusedIndex >= 0 && options[focusedIndex]) {
          var opt = options[focusedIndex];
          selectOption(opt.dataset.value, opt.dataset.label);
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
        trigger.focus();
      }
    });

    list.addEventListener('mousedown', function (e) {
      var opt = e.target.closest('.cloak-ss-option');
      if (opt) {
        e.preventDefault();
        selectOption(opt.dataset.value, opt.dataset.label);
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function caretSVG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
  }

  function buildUI() {
    var container = document.getElementById(pickerId);
    if (!container) return;

    // Use capitalized picker line labels if appropriate
    var labelPrefix = prefix.replace('cloak-', '').toUpperCase();
    if (labelPrefix === 'TUCK') labelPrefix = 'Tuck 3.5';

    container.innerHTML =
      '<div class="' + prefix + '-picker__row">' +
        '<label class="form__label">Manufacturer</label>' +
        '<div class="cloak-ss-wrap" id="cloak-ss-mfr">' +
          '<div class="cloak-ss-trigger" role="combobox" tabindex="0">' +
            '<span class="cloak-ss-trigger-label">All Manufacturers</span>' +
          '</div>' +
          '<span class="cloak-ss-caret">' + caretSVG() + '</span>' +
          '<div class="cloak-ss-dropdown">' +
            '<div class="cloak-ss-search-wrap">' +
              '<input type="text" class="cloak-ss-search" placeholder="Search manufacturers\u2026" autocomplete="off" spellcheck="false">' +
            '</div>' +
            '<div class="cloak-ss-list"></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="' + prefix + '-picker__row">' +
        '<label class="form__label">Gun Model</label>' +
        '<div class="cloak-ss-wrap" id="cloak-ss-gun">' +
          '<div class="cloak-ss-trigger" role="combobox" tabindex="0">' +
            '<span class="cloak-ss-trigger-label">Select Gun Model</span>' +
          '</div>' +
          '<span class="cloak-ss-caret">' + caretSVG() + '</span>' +
          '<div class="cloak-ss-dropdown">' +
            '<div class="cloak-ss-search-wrap">' +
              '<input type="text" class="cloak-ss-search" placeholder="Search gun models\u2026" autocomplete="off" spellcheck="false">' +
            '</div>' +
            '<div class="cloak-ss-list"></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="' + prefix + '-picker__row">' +
        '<label class="form__label" for="' + handId + '">Draw Hand</label>' +
        '<div class="select">' +
          '<select id="' + handId + '" class="select__select">' +
            '<option value="">Select Draw Hand</option>' +
            '<option value="Right">Right Hand</option>' +
            '<option value="Left">Left Hand</option>' +
          '</select>' +
          '<span class="svg-wrapper">' + caretSVG() + '</span>' +
        '</div>' +
      '</div>' +
      (showSize ?
      '<div id="' + sizeId + '-row" class="' + prefix + '-picker__row">' +
        '<label class="form__label" for="' + sizeId + '">Size</label>' +
        '<div class="select">' +
          '<select id="' + sizeId + '" class="select__select">' +
            '<option value="">Select Size</option>' +
            '<option value="X-Small">X-Small (23.8” to 28.5”)</option>' +
            '<option value="Small">Small (28.5” to 33.3”)</option>' +
            '<option value="Medium">Medium (33.3” to 38.0”)</option>' +
            '<option value="Large">Large (38.0” to 42.8”)</option>' +
            '<option value="X-Large">X-Large (42.8” to 47.8”)</option>' +
            '<option value="XX-Large">XX-Large (47.5” to 52.3”)</option>' +
          '</select>' +
          '<span class="svg-wrapper">' + caretSVG() + '</span>' +
        '</div>' +
      '</div>' : '') +
      (hideLight ? '' :
      '<div id="' + lightRowId + '" class="' + prefix + '-picker__row" style="display:none;">' +
        '<label class="form__label" for="' + lightId + '">Light / Laser</label>' +
        '<div class="select">' +
          '<select id="' + lightId + '" class="select__select">' +
            '<option value="">Select Light / Laser</option>' +
          '</select>' +
          '<span class="svg-wrapper">' + caretSVG() + '</span>' +
        '</div>' +
      '</div>') +
      (hideOptic ? '' :
      '<div id="' + opticRowId + '" class="' + prefix + '-picker__row" style="display:none;">' +
        '<label class="form__label" for="' + opticId + '">Optic Cut</label>' +
        '<div class="select">' +
          '<select id="' + opticId + '" class="select__select">' +
            '<option value="">Select Optic Cut</option>' +
          '</select>' +
          '<span class="svg-wrapper">' + caretSVG() + '</span>' +
        '</div>' +
      '</div>') +
      '<div id="' + statusId + '" style="display:none;font-size:1.3rem;color:#c00;margin-top:0.5rem;"></div>';

    createSearchableSelect('cloak-ss-mfr', getMfrOptions, function (value) {
      activeMfrFilter = value || '';
      selectedGun = null;
      var gunSS = document.getElementById('cloak-ss-gun');
      if (gunSS && gunSS._ss) gunSS._ss.reset();
      selectedHand = null;
      var handEl = document.getElementById(handId);
      if (handEl) handEl.value = '';
      if (showSize) {
        selectedSize = null;
        var sizeEl = document.getElementById(sizeId);
        if (sizeEl) sizeEl.value = '';
        refreshSize();
      }
      refreshLight();
      refreshOptic();
      trySelect();
      updateUrl();
    }, 'All Manufacturers');

    createSearchableSelect('cloak-ss-gun', getGunOptions, function (value) {
      selectedGun = value || null;
      selectedHand = null;
      selectedLight = null;
      selectedOptic = null;
      if (showSize) {
        selectedSize = null;
        var sizeEl = document.getElementById(sizeId);
        if (sizeEl) sizeEl.value = '';
      }

      if (selectedGun && !activeMfrFilter) {
        var mfr = getMfrForGun(selectedGun);
        if (mfr) {
          activeMfrFilter = mfr;
          var mfrSS = document.getElementById('cloak-ss-mfr');
          if (mfrSS && mfrSS._ss) mfrSS._ss.setValue(mfr, mfr);
        }
      }

      var handEl = document.getElementById(handId);
      if (handEl) handEl.value = '';
      refreshHandedness();
      if (showSize) refreshSize();
      refreshLight();
      refreshOptic();
      trySelect();
      updateUrl();
    }, 'Select Gun Model');

    attachEvents(container);
  }

  function attachEvents(container) {
    var handEl = document.getElementById(handId);
    if (handEl) {
      handEl.addEventListener('change', function () {
        selectedHand = this.value || null;
        selectedLight = null;
        selectedOptic = null;
        if (showSize) {
          selectedSize = null;
          var sizeEl = document.getElementById(sizeId);
          if (sizeEl) sizeEl.value = '';
          refreshSize();
        }
        refreshLight();
        refreshOptic();
        trySelect();
        updateUrl();
      });
    }

    if (showSize) {
      var sizeEl = document.getElementById(sizeId);
      if (sizeEl) {
        sizeEl.addEventListener('change', function () {
          selectedSize = this.value || null;
          trySelect();
          updateUrl();
        });
      }
    }

    var lightEl = document.getElementById(lightId);
    if (lightEl) {
      lightEl.addEventListener('change', function () {
        selectedLight = (this.value === '' || this.value === '__none__') ? null : this.value;
        var previousOptic = selectedOptic;
        refreshOptic();
        if (previousOptic !== null) {
          var opticSelect = document.getElementById(opticId);
          if (opticSelect) {
            var valueToSet = String(previousOptic);
            var exists = false;
            for (var i = 0; i < opticSelect.options.length; i++) {
              if (opticSelect.options[i].value === valueToSet) {
                exists = true;
                break;
              }
            }
            if (exists) {
              selectedOptic = previousOptic;
              opticSelect.value = valueToSet;
            }
          }
        }
        trySelect();
        updateUrl();
      });
    }

    var opticEl = document.getElementById(opticId);
    if (opticEl) {
      opticEl.addEventListener('change', function () {
        selectedOptic = this.value === '' ? null : this.value === 'true';
        trySelect();
        updateUrl();
      });
    }
  }

  function refreshHandedness() {
    var handSelect = document.getElementById(handId);
    if (!handSelect) return;

    if (!selectedGun) {
      Array.from(handSelect.options).forEach(function (opt) {
        if (!opt.value) return;
        opt.hidden = false;
      });
      return;
    }

    var available = {};
    allVariants.filter(function (v) { return v.gun === selectedGun; }).forEach(function (v) {
      available[v.handedness] = true;
    });

    Array.from(handSelect.options).forEach(function (opt) {
      if (!opt.value) return;
      opt.hidden = !available[opt.value];
    });

    if (handSelect.value && !available[handSelect.value]) {
      handSelect.value = '';
      selectedHand = null;
      selectedLight = null;
      refreshLight();
    }
  }

  function refreshSize() {
    if (!showSize) return;
    var sizeSelect = document.getElementById(sizeId);
    if (!sizeSelect) return;

    if (!selectedGun || !selectedHand) {
      sizeSelect.value = '';
      selectedSize = null;
      return;
    }

    var available = {};
    allVariants.forEach(function (v) {
      if (v.gun === selectedGun && v.handedness === selectedHand && v.size) {
        available[v.size] = true;
      }
    });

    Array.from(sizeSelect.options).forEach(function (opt) {
      if (!opt.value) return;
      opt.hidden = !available[opt.value];
    });

    if (sizeSelect.value && !available[sizeSelect.value]) {
      sizeSelect.value = '';
      selectedSize = null;
    }
  }

  function refreshLight() {
    var row = document.getElementById(lightRowId);
    var lightSelect = document.getElementById(lightId);
    if (!row || !lightSelect) {
      if (hideLight) selectedLight = null;
      return;
    }

    if (hideLight) {
      row.style.display = 'none';
      lightSelect.innerHTML = '<option value="__none__">No Light</option>';
      selectedLight = null;
      return;
    }

    if (!selectedGun || !selectedHand) {
      row.style.display = 'none';
      lightSelect.innerHTML = '<option value="">Select Light / Laser</option>';
      return;
    }

    var seen = {};
    var lights = [];
    allVariants.forEach(function (v) {
      if (v.gun !== selectedGun || v.handedness !== selectedHand) return;
      var key = v.light || '__none__';
      if (!seen[key]) {
        seen[key] = true;
        lights.push(v.light);
      }
    });

    lights.sort(function (a, b) {
      if (!a && !b) return 0;
      if (!a) return -1;
      if (!b) return 1;
      return a.replace(/\s+/g, '').localeCompare(b.replace(/\s+/g, ''));
    });

    var opts = '<option value="">Select Light / Laser</option>';
    lights.forEach(function (l) {
      opts += l
        ? '<option value="' + esc(l) + '">' + esc(l) + '</option>'
        : '<option value="__none__">No Light</option>';
    });
    lightSelect.innerHTML = opts;
    row.style.display = '';
  }

  function refreshOptic() {
    var row = document.getElementById(opticRowId);
    var opticSelect = document.getElementById(opticId);
    if (!row || !opticSelect) {
      if (hideOptic) selectedOptic = false;
      return;
    }

    if (hideOptic) {
      row.style.display = 'none';
      opticSelect.innerHTML = '<option value="false">No</option>';
      selectedOptic = false;
      return;
    }

    if (!selectedGun || !selectedHand) {
      row.style.display = 'none';
      opticSelect.innerHTML = '<option value="">Select Optic Cut</option>';
      return;
    }

    var seen = {};
    var optics = [];
    allVariants.forEach(function (v) {
      if (v.gun !== selectedGun || v.handedness !== selectedHand) return;
      var lightMatch = selectedLight === null ? !v.light : v.light === selectedLight;
      if (!lightMatch) return;
      var key = String(v.optic);
      if (!seen[key]) {
        seen[key] = true;
        optics.push(v.optic);
      }
    });

    optics.sort(function (a, b) { return a === b ? 0 : a ? -1 : 1; });
    var opts = '<option value="">Select Optic Cut</option>';
    optics.forEach(function (o) {
      opts += '<option value="' + o + '">' + (o ? 'Yes' : 'No') + '</option>';
    });
    opticSelect.innerHTML = opts;
    row.style.display = '';
    selectedOptic = null;
  }

  function trySelect() {
    var addBtn = document.querySelector('button[name="add"]');
    if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-disabled', 'true'); }

    var magUpsell = document.getElementById('cloak-mag-upsell');
    if (magUpsell) magUpsell.style.display = 'none';

    if (!selectedGun || !selectedHand) return;
    if (showSize && !selectedSize) return;

    var lightRow = document.getElementById(lightRowId);
    var lightSelect = document.getElementById(lightId);
    if (lightRow && lightRow.style.display !== 'none' && lightSelect && lightSelect.value === '') return;

    var opticRow = document.getElementById(opticRowId);
    var opticSelect = document.getElementById(opticId);
    if (opticRow && opticRow.style.display !== 'none' && opticSelect && opticSelect.value === '') return;

    var entry = null;
    for (var i = 0; i < allVariants.length; i++) {
      var v = allVariants[i];
      if (v.gun === selectedGun && v.handedness === selectedHand) {
        var sizeMatch = showSize ? (v.size === selectedSize) : true;
        var lightMatch = hideLight ? true : (selectedLight === null ? !v.light : v.light === selectedLight);
        var opticMatch = hideOptic ? true : (v.optic === selectedOptic);
        if (lightMatch && opticMatch && sizeMatch) { entry = v; break; }
      }
    }

    if (!entry) {
      showStatus('This combination is not available.');
      return;
    }

    var shopifyVariant = null;
    if (entry.sku) {
      for (var j = 0; j < shopifyVariants.length; j++) {
        if (shopifyVariants[j].sku === entry.sku) {
          shopifyVariant = shopifyVariants[j];
          break;
        }
      }
    }
    if (!shopifyVariant) {
      shopifyVariant = shopifyVariants[0] || null;
    }
    if (!shopifyVariant) {
      showStatus('Variant not found.');
      return;
    }

    hideStatus();
    applyVariant(shopifyVariant, entry);
  }

  function setLineItemProperty(form, name, value) {
    var existing = form.querySelector('input[name="properties[' + name + ']"]');
    if (existing) {
      existing.value = value;
    } else {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + name + ']';
      hidden.value = value;
      form.appendChild(hidden);
    }
  }

  function removeLineItemProperty(form, name) {
    var existing = form.querySelector('input[name="properties[' + name + ']"]');
    if (existing) existing.remove();
  }

  function applyVariant(shopifyVariant, entry) {
    var input =
      document.querySelector('input[name="id"].product-variant-id') ||
      document.querySelector('#product-form-' + sectionId + ' input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (input) {
      var variantToUse = shopifyVariant;
      if (entry.black_only) {
        var baseHolster = allVariants.find(function (v) {
          return !v.light && v.optic === false && v.black_only;
        });
        if (baseHolster) {
          for (var j = 0; j < shopifyVariants.length; j++) {
            if (shopifyVariants[j].sku === baseHolster.sku) {
              variantToUse = shopifyVariants[j];
              break;
            }
          }
        }
      }

      input.value = variantToUse.id;
      input.disabled = false;

      var form = input.closest('form');
      if (form) {
        setLineItemProperty(form, 'Gun Model', entry.manufacturer + ' ' + entry.gun);
        setLineItemProperty(form, 'Draw Hand', entry.handedness);
        if (showSize && entry.size) {
          setLineItemProperty(form, 'Size', entry.size);
        }
        setLineItemProperty(form, 'Light / Laser', entry.light || 'No Light');
        setLineItemProperty(form, 'Optic Cut', entry.optic ? 'Yes' : 'No');
        var leadTimeValue = (shopifyVariant.lead_time != null && shopifyVariant.lead_time > 0) ? String(shopifyVariant.lead_time) : '';
        setLineItemProperty(form, 'Lead Time', leadTimeValue);
        setLineItemProperty(form, '_sku', entry.sku || '');
        removeLineItemProperty(form, '_no_shell_addon');

        window.cloakSingleProperties = {
          'Gun Model': entry.manufacturer + ' ' + entry.gun,
          'Draw Hand': entry.handedness,
          'Light / Laser': entry.light || 'No Light',
          'Optic Cut': entry.optic ? 'Yes' : 'No'
        };
        if (showSize && entry.size) {
          window.cloakSingleProperties['Size'] = entry.size;
        }
      }
    }

    var magUpsell = document.getElementById('cloak-mag-upsell');
    if (magUpsell) magUpsell.style.display = 'block';

    var available = shopifyVariant.available !== false;
    var addBtn = document.querySelector('button[name="add"]');
    if (addBtn) {
      addBtn.disabled = !available;
      if (!available) addBtn.setAttribute('aria-disabled', 'true');
      else addBtn.removeAttribute('aria-disabled');
    }

    updateSku(entry.sku);
    if (entry.price != null) {
      var compareAt = shopifyVariant ? shopifyVariant.compare_at_price : null;
      updatePrice(entry.price, compareAt);
    }
    if (entry.image) updateImage(entry.image);
    if (shopifyVariant.lead_time != null) updateLeadTime(shopifyVariant.lead_time);
    updateColorsVisibility(entry.black_only);
  }

  function updateColorsVisibility(blackOnly) {
    var section = document.querySelector('.cloak-colors-section');
    if (!section) return;
    if (blackOnly) {
      section.classList.add('black-only');
      var activeItem = document.querySelector('.cloak-color-item.active');
      if (activeItem && activeItem.getAttribute('data-handle') !== 'cloak-black') {
        var blackItem = document.querySelector('.cloak-color-item[data-handle="cloak-black"]');
        if (blackItem) {
          var clickable = blackItem.querySelector('.cloak-color-clickable') || blackItem;
          clickable.click();
        }
      }
    } else {
      section.classList.remove('black-only');
    }
  }

  function updateSku(sku) {
    var el = document.getElementById('Sku-' + sectionId);
    if (!el) return;
    el.classList.remove('visibility-hidden');
    var inner = el.querySelector('.product__sku--value') || el;
    inner.textContent = sku || '';
  }

  function updatePrice(price, compareAtPrice) {
    var priceContainer = document.querySelector('#price-' + sectionId + ' .price');
    if (!priceContainer) return;
    if (prefix && prefix.startsWith('cloak') && (price === 59.99 || Math.abs(price - 59.99) < 0.01)) {
      compareAtPrice = 79.99;
    }
    if (compareAtPrice && compareAtPrice > price) {
      priceContainer.classList.add('price--on-sale');
      var regularEl = priceContainer.querySelector('.price__sale .price-item--regular');
      if (regularEl) regularEl.textContent = '$' + compareAtPrice.toFixed(2) + ' USD';
      var saleEl = priceContainer.querySelector('.price-item--sale.price-item--last');
      if (saleEl) saleEl.textContent = '$' + price.toFixed(2) + ' USD';
    } else {
      priceContainer.classList.remove('price--on-sale');
      var regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
      if (regularEl) regularEl.textContent = '$' + price.toFixed(2) + ' USD';
    }
  }

  // Update product main image
  function updateImage(url) {
    var mainImg = document.querySelector('.product-media-container img.image-magnify-lightbox');
    if (mainImg) {
      mainImg.src = url;
      if (mainImg.hasAttribute('srcset')) mainImg.srcset = url;
    }
  }

  function updateLeadTime(leadTime) {
    var el = document.getElementById('lead-time-value');
    if (!el) return;
    el.textContent = leadTime === 1 ? '1 business day.' : leadTime + ' business days.';
  }

  function showPickerError(msg) {
    var container = document.getElementById(pickerId);
    if (container) container.innerHTML = '<p style="color:#c00;font-size:1.3rem;">' + msg + '</p>';
  }

  function showStatus(msg) {
    var el = document.getElementById(statusId);
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function hideStatus() {
    var el = document.getElementById(statusId);
    if (el) { el.style.display = 'none'; }
  }

  // Initialize
  boot();
};
